/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select, MenuItem, AppBar, Toolbar, Typography, RadioGroup, Radio, FormControlLabel,
  FormLabel
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderAdd(props) {
  const { login, onCloseAddPop, tcidParent } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState(tcidParent);
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState("");
  const [date, setDate] = useState(null);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [pName, setPname] = useState("");
  const [amount, setAmount] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [sdate, setSdate] = useState(null);
  const [tmcd, setTmcd] = useState("");
  const [pid, setPid] = useState("");
  const [method, setMethod] = useState("");
  const [fcid, setFcid] = useState('');

  const onSubmit = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/purchase_add", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      sdate: sdate,
      tmcd: tmcd,
      pid: pid,
      amount: amount,
      method: method,
      fcid: fcid,
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onCloseAddPop();
        }
      );
    }
  };

  const onCidChange = (e) => {
    pr("cid change");
  };

  const handleClose = () => { };

  // MemberSearch
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  const onCalendarChange = (dt) => {
    let dt_format = moment(dt).format("YYYY-MM-DD");
    setSdate(dt_format);
  };

  // ProductSearch
  const onShowProductSearchClick = () => {
    setShowProductSearch(true);
  };

  const onHideProductSearchClick = () => {
    setShowProductSearch(false);
  };

  const onAfterProductSearchClick = (params) => {
    const { id, name, amount } = params;
    setPname(name);
    setAmount(amount);
    setSalePrice(amount);
    setPid(id);
  };

  const onAmountChange = (e) => {
    setAmount(e.target.value);
  }

  return (
    <Box>

      {/* 사용자 찾기 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => { }}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          tcidParent={tcid}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      {/* 상품 찾기 */}
      <Dialog
        open={showProductSearch}
        onClose={() => { }}
        fullWidth={true}
        maxWidth="lg"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>상품찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideProductSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ProductSearch
          login={login}
          tcidParent={tcid}
          onAfterProductSearchClick={onAfterProductSearchClick}
          onHideProductSearchClick={onHideProductSearchClick}
        />
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >

        <Box>
          <CenterSelect
            login={login}
            tcidParent={tcid}
            setTcidParent={setTcid}
          />
        </Box>

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={sName}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 시작일 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <MobileDatePicker
              allowSameDateSelection={true}
              value={sdate}
              label="시작일"
              renderInput={(params) => <TextField size="small" {...params} />}
              onChange={onCalendarChange}
              inputFormat={"yyyy.MM.dd"}
              autoComplete="off"
            />
          </LocalizationProvider>
        </Box>

        {/* 상품명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="상품명"
            size="small"
            sx={{
              width: "280px",
            }}
            autoComplete="off"
            value={pName}
          ></TextField>
          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowProductSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 팜매가 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="판매가"
            size="small"
            autoComplete="off"
            value={salePrice}
            sx={{ width: 180 }}
          ></TextField>
        </FormControl>

        {/* 구매가 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="amount"
            label="구매가"
            size="small"
            autoComplete="off"
            value={amount}
            sx={{ width: 180 }}
            onChange={onAmountChange}
          ></TextField>
        </FormControl>

        {/* 결제방식 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>결제방식</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="method"
            onChange={(e) => { setMethod(e.target.value) }}
          >
            <FormControlLabel value="5" control={<Radio />} label="카드(현장)" />
            <FormControlLabel value="1" control={<Radio />} label="카드(온라인)" />
            <FormControlLabel value="6" control={<Radio />} label="현금(현장)" />
            <FormControlLabel value="2" control={<Radio />} label="현급(계좌)" />
            <FormControlLabel value="9" control={<Radio />} label="무료" />
          </RadioGroup>
        </FormControl>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onCloseAddPop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
export default OrderAdd;

// ======================= //
// 즐겨찾는 센터
// ======================= //
function FcenterSelect(props) {

  const { setFcid } = props;
  const [rows, setRows] = useState([]);
  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/center_list");
    setRows(result.data);
  }

  useEffect(() => {
    load_data();
  }, [])

  return <FormControl size="small" sx={{ width: 280 }}>
    <InputLabel>즐겨 찾는 센터</InputLabel>
    <Select onChange={(e) => { setFcid(e.target.value) }}>
      {
        rows.map((item, index) => {
          return <MenuItem key={index} value={item.cid}>{item.center}:{item.location}</MenuItem>
        })
      }
    </Select>
  </FormControl>
}